import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

const PermissionRoute = ({ permission, element }) => {
  const user = useSelector(state => state.authReducer?.user);
  const userPermissions = useSelector(state => state.authReducer?.userPermissions);
  
  // ⏳ Wait for user to load
  if (!user) {
    return null; // or loader/spinner
  }

  if (user.userName == 'admin') {
    return element;
  }
  const permissions = userPermissions || [];

  // allow if no permission required
  if (!permission) {
    return element;
  }

  // allow if authorized
  if (permissions.includes(permission)) {
    return element;
  }

  // block if unauthorized
  return <Navigate to="/pages/errors/error403" replace />;
};

export default PermissionRoute;
